export var TelemetryKeys;
(function (TelemetryKeys) {
    TelemetryKeys["CLIENT_START_TIME"] = "ClientStartTime";
    TelemetryKeys["CLIENT_VERSION"] = "ClientVersion";
    TelemetryKeys["LOCAL_TIME"] = "LocalTime";
    TelemetryKeys["LUCID_USER"] = "LucidUser";
    TelemetryKeys["ROOT_LOG_LEVEL"] = "RootLogLevel";
    TelemetryKeys["UTC_TIME"] = "UTCTime";
    TelemetryKeys["APPLICATION"] = "Application";
    TelemetryKeys["USER_AGENT"] = "UserAgent";
})(TelemetryKeys || (TelemetryKeys = {}));
export function createLoginTelemetryRecord(startTime, version, localTime, username, logLevel, utcTime, application, userAgent) {
    return {
        [TelemetryKeys.CLIENT_START_TIME]: startTime,
        [TelemetryKeys.CLIENT_VERSION]: version,
        [TelemetryKeys.LOCAL_TIME]: localTime,
        [TelemetryKeys.LUCID_USER]: username,
        [TelemetryKeys.ROOT_LOG_LEVEL]: logLevel,
        [TelemetryKeys.UTC_TIME]: utcTime,
        [TelemetryKeys.APPLICATION]: application,
        [TelemetryKeys.USER_AGENT]: userAgent,
    };
}
